import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-white" data-id="element-174" data-mp="2lmspylv9v6kb">
      <div className="max-w-4xl mx-auto" data-id="element-175" data-mp="26yfudq03jpqc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-176" data-mp="26xmsb2c31oej">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-177" data-mp="21z37545bcgn8">
            💬 Does This Sound Familiar?
          </h2>
          <p className="text-lg text-slate leading-relaxed bg-mist p-6 rounded-2xl border border-mist-dark shadow-sm text-left" data-id="element-178" data-mp="1o0vbr0nxdne6">
            Sunday evening. You have training tomorrow. You&apos;re still searching for sprint
            drills, trying to organize jump progressions, deciding how many throws your
            athletes should complete, adjusting endurance work and wondering whether the
            session actually fits their current level.
            <br data-id="element-179" data-mp="1u1ty4s2rmggc" />
            <br data-id="element-180" data-mp="1u2dj6hnppkyl" />
            <span className="text-navy font-medium" data-id="element-181" data-mp="1u0sn2nlr1tym">
              Not because you don&apos;t understand Track &amp; Field.
            </span>{' '}
            Because building structured training across multiple events takes time. You have
            sprinters. Jumpers. Throwers. Hurdlers. Endurance athletes. Different levels,
            different weaknesses, different competition schedules. And every week,
            you&apos;re expected to turn all of that into organized, professional training.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-182" data-mp="1p04mpbbms0rq">
          <h3 className="text-xl font-bold text-navy mb-8 text-center" data-id="element-183" data-mp="2vitdqklr1df5">
            The Real Cost of Not Having the Right Coaching System
          </h3>
          <div className="overflow-hidden rounded-xl border border-mist-dark bg-white shadow-sm" data-id="element-184" data-mp="1t4n90wjetrh6">
            <div className="hidden sm:grid grid-cols-2 bg-navy text-xs uppercase tracking-wider font-bold text-white" data-id="element-185" data-mp="1y2orbf90hmrl">
              <p className="px-5 py-3" data-id="element-186" data-mp="223qta3ubccx9">The Problem</p>
              <p className="px-5 py-3 border-l border-white/20" data-id="element-187" data-mp="273v9rtv817nh">The Real Impact</p>
            </div>
            {painPoints.map((point, index) => <motion.div key={point.problem} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid sm:grid-cols-2 border-t first:border-t-0 border-mist-dark" data-id="element-188" data-mp="1acudovgvbu6a" data-mpi={index}>
                <p className="px-5 py-4 text-navy text-sm leading-relaxed" data-id="element-189" data-mp="vprg6osjpliy">
                  <span className="mr-2 text-alert font-bold" data-id="element-190" data-mp="vnof99puu7zg">✕</span>
                  {point.problem}
                </p>
                <p className="px-5 pb-4 sm:py-4 text-slate text-sm leading-relaxed sm:border-l border-mist-dark" data-id="element-191" data-mp="j75j68lcgbq9">
                  {point.impact}
                </p>
              </motion.div>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-mist-dark" data-id="element-192" data-mp="a70fo9j9txhd">
            <p className="text-2xl font-serif font-bold text-navy" data-id="element-193" data-mp="57e21yzj6f81">
              Stop rebuilding your coaching system{' '}
              <span className="text-gold-solid" data-id="element-194" data-mp="ge18inajd09">every single week.</span>
            </p>
            <p className="text-xl mt-4 text-slate" data-id="element-195" data-mp="3rmfgz4i7aus8">
              Solve Your Track &amp; Field Training Plan in Just 5 Minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}